import dayjs from 'dayjs'
import doneCreate from '../../../assets/images/done-create.svg'
import errorAlert from '../../../assets/images/error-alert.svg'
import { getPaymentDetailAmount, getPaymentDetailValue } from '../helper'
import NumberFormat from 'react-number-format'
import { WatDatePicker } from '../../../component/datePicker'
import { ChangeEvent, useEffect, useState } from 'react'
import { IOtherPaymentProps, IPaymentDetailProps } from './ipaymentDetailProps.interface'
import { PayInBank } from '../../../component/entryForm/bankAccount'
import { PAYMENTMODE } from '../../../constants'
import { CashPayIn } from './cashPayIn'
import { ChequePayIn } from './chequePayIn'
import { CompanyCheque } from './companyCheque'
import { QRCode } from './qrCode'
import { getPaymentMethod } from '../../../helpers/texthelper'
import { DocumentDetailModel } from '../../../models/documentDetail'
import { id } from 'date-fns/locale'

import { isBranchStaff } from '../../../helpers/roles'
import { RootReducers } from '../../../redux/reducers'
import { useSelector } from 'react-redux'

export const OtherPay: React.VFC<IOtherPaymentProps> = ({
  paymentDetail,
  handleEnterKey,
  formErrors,
  paymentMethod,
  onChangeAmountDetail,
  handlePayInDateChangeAmountDetail,
  handleWatDatePickerChangeAmountDetail,
  branchCode,
  handleCheckDetail,
  handleClearCheckDetail,
  value
}) => {
  const [paymentType, setPaymentType] = useState(value)
  const loginData = useSelector((state: RootReducers) => state.loginReducer)
  // const handlePayInDateChange = (christDate: any, buddhistDate: any) => {
  //   handlePayInDateChangeAmountDetail(christDate, buddhistDate, method.paymentMethod.id)
  // }
  // useEffect(() => {
  //   // Update the document title using the browser API
  //   const payMethod: DocumentDetailModel[] = paymentDetail.filter(
  //     item => item.isCheck === true && item.paymentMethod.id != 4
  //   )
  //   if (payMethod && payMethod.length > 0) setPaymentType(payMethod[0].paymentMethod.id)
  // }, [])

  const handleOtherPayGroupChange = (e: any) => {
    //console.log(e.target.value)
    const paymentTypeId = e.target.value

    if (paymentTypeId) handleCheckDetail(getPaymentMethod(parseInt(paymentTypeId)).name)
    setPaymentType(paymentTypeId)
  }

  const renderPaymentType = (paymentTypeId: number) => {
    console.log('renderPaymentType', paymentTypeId)

    switch (paymentTypeId) {
      case 5:
        return (
          <CashPayIn
            branchCode={branchCode}
            paymentDetail={paymentDetail}
            paymentMethod={getPaymentMethod(paymentTypeId)}
            formErrors={formErrors}
            onChangeAmountDetail={onChangeAmountDetail}
            handleEnterKey={handleEnterKey}
            handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
            handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
          ></CashPayIn>
        )
      case 6:
        return (
          <ChequePayIn
            branchCode={branchCode}
            paymentDetail={paymentDetail}
            paymentMethod={getPaymentMethod(paymentTypeId)}
            formErrors={formErrors}
            onChangeAmountDetail={onChangeAmountDetail}
            handleEnterKey={handleEnterKey}
            handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
            handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
          ></ChequePayIn>
        )
      case 7:
        return (
          <CompanyCheque
            branchCode={branchCode}
            paymentDetail={paymentDetail}
            paymentMethod={getPaymentMethod(paymentTypeId)}
            formErrors={formErrors}
            onChangeAmountDetail={onChangeAmountDetail}
            handleEnterKey={handleEnterKey}
            handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
            handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
          ></CompanyCheque>
        )
      case 8:
        return (
          <QRCode
            branchCode={branchCode}
            paymentDetail={paymentDetail}
            paymentMethod={getPaymentMethod(paymentTypeId)}
            formErrors={formErrors}
            onChangeAmountDetail={onChangeAmountDetail}
            handleEnterKey={handleEnterKey}
            handleWatDatePickerChangeAmountDetail={handleWatDatePickerChangeAmountDetail}
            handlePayInDateChangeAmountDetail={handlePayInDateChangeAmountDetail}
          ></QRCode>
        )
      default:
        console.log('default')
        break
    }
  }
  const hideQRPayment = (id: number): string => {
    if (id == 8 && !isBranchStaff(loginData.account?.agentInfo.role as string)) return 'none'
    return 'block'
  }
  return (
    <div>
      <div className="required">
        <span className="amount-text">โปรดระบุ</span>
        {/* <select
          className="field-input"
          name="other_PayGroup"
          onChange={handleOtherPayGroupChange}
          value={paymentType}
        >
          <option value="">เลือก</option>
          <option value="6">นำเช็คเข้าบัญชีธนาคาร</option>
          <option value="7">เช็คสั่งจ่ายโดย FWD</option>
          <option value="5">โอนเงินสดเข้าบัญชีธนาคาร</option>
          <option value="8">QR Code</option>
        </select> */}
        <div className="container-checkbox otherpay">
          {paymentDetail
            .filter(p => p.paymentMethod.isActive === false)
            .map(item => {
              return (
                <li
                  key={item.paymentMethod.id}
                  style={{
                    display: hideQRPayment(item.paymentMethod.id)
                  }}
                >
                  <label
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: 'fit-content'
                    }}
                  >
                    <input
                      type="radio"
                      checked={item.isCheck}
                      onChange={() => handleClearCheckDetail(item.paymentMethod.id, true)}
                      //onBlur={() => clearAmountDetailCheckbox(item.paymentMethod.name)}
                    />
                    {item.paymentMethod.name}
                  </label>
                  {item.isCheck && renderPaymentType(item.paymentMethod.id)}
                </li>
              )
            })}
        </div>
      </div>

      {formErrors.other_PayGroup && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}
      {/* <div>{renderPaymentType()}</div> */}
    </div>
  )
}
